<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="start"><a id="chap1">Foreword</a></h1><a id="chap1">
<p class="noind" style="margin-top:30px;">T<span class="small">HIS IS A WORK</span> of fiction. A work of history must be as true as the author can make it; a historical novel, because it is a work of fiction, can be as false as the author needs it to be. Geography and architecture, as well as time itself, can (and have) been changed to suit the needs of the story.</p>
<p class="ind">In writing this novel, I have incorporated some well-known real people as characters and certain public events, such as baseball games, into the narrative. However, no implication should be drawn (and certainly none is intended) that any of these real people used as characters said, did, or were involved in the things written in the novel. My purpose was solely to evoke an era and create a real-seeming 1953, not to report events.</p>
<p class="ind">I hasten to add that most of the characters (including all the bad guys) are totally fictitious. Therefore, simply because a character may have been portrayed in the novel as occupying a certain position or job, the reader should not construe this to mean that the character was meant to represent in any way whatsoever the person who actually held that position or job at the time described in the novel; any resemblance is entirely coincidental.</p>
<p class="ind">Finally, I’d like to take this opportunity to thank some people: Carol Brener, Read Evans, and Steve Fabian, for making the contents of their libraries available to me; Janice Young Brooks, for showing me Kansas City; and especially Meredith Bernstein, who stayed with the pitch until she connected.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5start.vue?7da18d0b